module.exports = __webpack_public_path__ + "img/bot_intent_liucheng.4b5ebcd5.svg";